import * as actions from '../actions';

import createSection from './createSection.app.reducer';
import deleteSection from './deleteSection.app.reducer';
import getSection from './getSection.app.reducer';
import getVersion from './getVersion.app.reducer';
import dismissGetStarted from './dismissGetStarted.app.reducer';
import displayRevertModal from './displayRevertModal.app.reducer';
import fetchSections from './fetchSections.app.reducer';
import hideUnhideMaterial from './hideUnhideMaterial.app.reducer';
import importMaterials from './importMaterials.app.reducer';
import patchSection from './patchSection.app.reducer';
import revertSectionToVersion from './revertSectionToVersion.app.reducer';
import saveSection from './saveSection.app.reducer';
import leaveWithoutSaving from './leaveWithoutSaving.app.reducer';
import setEditing from './setEditing.app.reducer';
import toggleFolder from './toggleFolder.app.reducer';
import toggleMaterialEducatorOnly from './toggleMaterialEducatorOnly.app.reducer';
import openCloseRenameFolder from './openCloseRenameFolder.app.reducer';
import openCloseDeleteFolder from './openCloseDeleteFolder.app.reducer';
import editFolder from './editFolder.app.reducer';
import deleteFolder from './deleteFolder.app.reducer';
import openCloseScheduleMaterial from './openCloseScheduleMaterial.app.reducer';
import openCloseScheduleSection from './openCloseScheduleSection.app.reducer';
import editMaterial from './editMaterial.app.reducer';

const initialState = {
  editing: false,
  hasDismissedGetStarted: false,
  hasFetchedSections: false,
  isDeletingSection: false,
  isFetchingSections: false,
  isLoadingContent: false,
  sectionId: undefined,
  isLoadingVersion: false,
  isFetchingVersions: false,
  isHidingMaterial: false,
  isImportingMaterials: false,
  isRevertingSection: false,
  isErrored: false,
  isSavingSection: false,
  hasSavingSectionErrored: false,
  sections: null,
  currentDeleteCandidate: null,
  selectedContent: null,
  currentRevertCandidate: null,
  leaveDestinationPath: null,
  expandedFolders: {},
  isMaterialEducatorOnlyExpanded: true,
  renameFolderDialogOpenFor: null,
  isSavingFolder: false,
  deleteFolderDialogOpenFor: null,
  isDeletingFolder: false,
  scheduleMaterialDialogOpenFor: null,
  scheduleSectionDialogOpenFor: null,
};

const reset = () => ({ ...initialState });

const reducers = {
  [actions.CLASSROOM_MODULE_CREATE_SECTION]: createSection,
  [actions.CLASSROOM_MODULE_DELETE_SECTION]: deleteSection,
  [actions.CLASSROOM_MODULE_GET_SECTION]: getSection,
  [actions.CLASSROOM_MODULE_DISMISS_GET_STARTED]: dismissGetStarted,
  [actions.CLASSROOM_MODULE_FETCH_SECTIONS]: fetchSections,
  [actions.CLASSROOM_MODULE_HIDEUNHIDE_MATERIAL]: hideUnhideMaterial,
  [actions.CLASSROOM_MODULE_IMPORT_SECTIONS]: importMaterials,
  [actions.CLASSROOM_MODULE_PATCH_SECTION]: patchSection,
  [actions.CLASSROOM_MODULE_SAVE_CURRENT_SECTION]: saveSection,
  [actions.CLASSROOM_MODULE_LEAVE_WITHOUT_SAVING]: leaveWithoutSaving,
  [actions.CLASSROOM_MODULE_RESET]: reset,
  [actions.CLASSROOM_MODULE_SET_EDITING]: setEditing,
  [actions.CLASSROOM_MODULE_GET_VERSION]: getVersion,
  [actions.CLASSROOM_MODULE_DISPLAY_REVERT_MODAL]: displayRevertModal,
  [actions.CLASSROOM_MODULE_REVERT]: revertSectionToVersion,
  [actions.CLASSROOM_MODULE_TOGGLE_FOLDER]: toggleFolder,
  [actions.CLASSROOM_MODULE_TOGGLE_MATERIAL_EDUCATOR_ONLY]:
    toggleMaterialEducatorOnly,
  [actions.CLASSROOM_OPEN_CLOSE_RENAME_FOLDER]: openCloseRenameFolder,
  [actions.CLASSROOM_OPEN_CLOSE_DELETE_FOLDER]: openCloseDeleteFolder,
  [actions.CLASSROOM_EDIT_FOLDER]: editFolder,
  [actions.CLASSROOM_DELETE_FOLDER]: deleteFolder,
  [actions.CLASSROOM_OPEN_CLOSE_SCHEDULE_MATERIAL]: openCloseScheduleMaterial,
  [actions.CLASSROOM_OPEN_CLOSE_SCHEDULE_SECTION]: openCloseScheduleSection,
  [actions.CLASSROOM_MODULE_EDIT_MATERIAL]: editMaterial,
};

const reducer = (state = initialState, action) => {
  if (!action) {
    return state;
  }

  const r = reducers[action.type];
  return r ? r(state, action) : state;
};

export default reducer;
